// export async function getAllUsers() {

//     try{
//         const response = await fetch('/api/users');
//         return await response.json();
//     }catch(error) {
//         return [];
//     }
    
// }
import { setCookie } from 'cookies-next';

export async function createUser(data) {
  // console.log(data, 'test');
  return await fetch(`https://admin.shankariasacademy.com/siaadminpanel/web/form/submit?formType=`+ data.fields.formType , {
        method: 'POST',
        mode: 'cors',
        headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
        body: JSON.stringify(data)
      })
      .then((response)=> response.json())      
      .then((data)=>{
        if (data.status != 200) {
          throw new Error(data.message);
        }
        setCookie('OtpToken', data.data[0].id,{secure: false,maxAge: 60 * 30,sameSite: "strict",path: "/"});
        return data;
      }).catch((error)=>{
        throw new Error(error);
      })      
}